import React, { useEffect } from 'react';
import ErrorPage from '../../../../common/src/components/ErrorPage';
import LoadingScreen from '../../../../common/src/components/LoadingScreen';
import LoadingSpinner from '../../../../common/src/components/LoadingSpinner';
import { useCompleteConversation } from '../../../../conversations/src/features/detail/shared/api/completeConversation';
import { useConversation } from '../../../../conversations/src/features/detail/shared/api/getConversationById';
import AdvisoryAppShell from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import useSessionId from '../../../../flows/src/hooks/useSessionId';
import BikmoSign from './sign';

const BikmoFinalize: React.FC = () => {
  const sessionId = useSessionId();
  const { mutate, data, isLoading, isIdle, isError } = useCompleteConversation(
    sessionId,
    false,
  );

  const { data: conversation, isLoading: isLoadingConversation } =
    useConversation(sessionId);

  useEffect(() => {
    if (isIdle) mutate(undefined);
  }, []);

  if (isError)
    return (
      <AdvisoryAppShell>
        <ErrorPage />
      </AdvisoryAppShell>
    );

  if (isLoading || !data)
    return (
      <AdvisoryAppShell>
        <LoadingScreen />
      </AdvisoryAppShell>
    );

  if (!conversation || isLoading || isLoadingConversation)
    return <LoadingSpinner />;

  return (
    <BikmoSign
      quoteId={conversation.quote_id || ''}
      partyId={conversation.prospect?.id || ''}
      contractStartDate={
        conversation.specs.contract_commencement_date as string
      }
    />
  );
};

export default BikmoFinalize;
